var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.08 3L5 2.33L2 2.08V1C2 0.734784 1.89464 0.48043 1.70711 0.292893C1.51957 0.105357 1.26522 0 1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20C1.26522 20 1.51957 19.8946 1.70711 19.7071C1.89464 19.5196 2 19.2652 2 19V11.92L5 11.67L13.08 11C13.3311 10.9798 13.5654 10.8657 13.7359 10.6803C13.9065 10.4949 14.0008 10.2519 14 10V4C14.0008 3.74808 13.9065 3.50514 13.7359 3.31974C13.5654 3.13434 13.3311 3.02015 13.08 3ZM4 9.75L2 9.91V4.09L4 4.25V9.75ZM8 9.41L6 9.58V4.42L8 4.59V9.41ZM12 9.08L10 9.25V4.75L12 4.92V9.08Z",
    fill: "#FF6376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.c1e5ff5b4158214f45daf53f6a3a4eda.svg";
export { ForwardRef as ReactComponent };